<template>
  <svg
  ref="svgChart"
  :width="chartLayout.size"
  :height="chartLayout.size"
  :style="{transform: `translate(${chartLayout.anchorLeft}px, ${chartLayout.anchorTop}px)`, 'shape-rendering':'geometricPrecision'}"
  >
    <defs>
      <clipPath id="clippingArea" ref="clippingArea">
      </clipPath>
    </defs>
    <!-- inline body svg
    svg position and scale set with transform matrix
    body area = 75% given dimensions-->
    <svg>
      <g
      style="display:inline"
      :transform="'matrix('+ chartLayout.size * 0.00123 +', 0, 0, -'+ chartLayout.size * 0.00111 +', '+ chartLayout.size * 0.713 +', '+ chartLayout.size * 0.355 +')'"
      >
        <g style="opacity:0.10000598">
          <path
          d="m 0,0 c -9.8601622,12.504349 -27.132548,-0.74916713 -40.09975,3.200875 6.846198,28.574038 -19.39225,-17.66761 -35.236678,-6.9110099 -26.433182,
          .65236956 -53.156402,-1.1032888 -79.524752,3.84575419 -23.88244,3.46553521 -48.16418,5.01512211 -71.78738,9.72455261 -25.03926,20.2043641 22.48329,
          43.3773171 7.64277,70.3379761 -2.03233,30.791672 -57.10609,30.791672 -59.13842,0 -14.3822,-26.416574 36.35289,-56.234757 1.38521,-71.674148 -33.45258,
          -3.4196986 -66.70937,-10.0177611 -100.32169,-10.8922969 -21.51634,5.8950864 -44.32293,-7.0093022 -64.89406,2.16943752 C -450.42395,6.4197435 -466.11274,
          24.408603 -458.77788,3.200875 -471.72029,-0.75154252 -489.00719,12.49395 -498.878,0 c -6.91728,-20.619877 18.22643,-18.393815 31.155,-20.043036 34.66058,
          -2.652462 69.25771,-9.223397 104.06802,-5.440261 17.11498,-1.180514 34.51754,-0.862128 51.41215,-3.678312 13.6398,-8.628948 11.00847,-27.291317 15.7895,-41.132166 4.32031,
          -26.978924 17.33525,-54.415535 7.39803,-81.614095 -6.26292,-21.23749 -11.87395,-43.19677 -7.21344,-65.36939 3.0375,-35.40728 9.73892,-70.65489 9.81183,-106.19477 -3.20603,
          -25.64762 -11.63995,-51.73243 -3.06741,-77.28245 3.42896,-23.57465 14.89349,-47.10405 8.57054,-70.9782 -6.5275,-11.27393 -7.24889,-29.41617 10.68436,-25.18032 31.2115,
          2.60344 2.11296,39.11513 8.23132,57.21643 4.43293,32.35931 8.64805,64.87974 5.56329,97.57291 -2.21697,39.982 3.85898,79.77619 6.16081,119.63866 2.68119,6.32995 2.61571,
          -18.23542 3.80142,-26.47671 3.47173,-38.5744 6.24349,-77.24556 3.1525,-115.94707 -2.84435,-31.4097 9.23449,-62.34822 5.84322,-93.53908 -10.89795,-16.82917 -7.74718,
          -44.6335 16.71886,-38.46514 19.7794,8.26514 -8.18531,32.85791 1.154,48.491 4.65316,26.16427 13.59054,51.81355 14.32925,78.4612 -3.60082,26.80368 -10.70879,53.68527 -5.21313,
          80.79281 2.96625,32.8779 8.62891,65.6295 9.65588,98.59924 -3.13321,27.92163 -19.61701,55.09697 -9.77762,83.53534 5.48272,23.798724 8.91265,48.225944 15.76181,71.606316 10.59697,
          12.15661 28.63597,6.593505 43.02996,9.15309 26.29493,1.611244 52.619905,-2.201225 78.802185,2.170719 22.928643,2.960725 46.479533,2.895687 68.94729,8.115035 C 2.7404491,
          -13.723307 0.73692563,-5.3759927 0,0 Z"
          style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none;"
          />
        </g>
      </g>
    </svg>
    <!-- end of inline body svg-->

    <g ref="numberLabels" />
    <g ref="areaLabels" />
    <g ref="titleLabel" />

    <g ref="axes"/>
    <g ref="labels">
      <g ref="newNumberLabels"/>
      <g ref="newAreaLabels"/>
      <g ref="newTitleLabel"/>
    </g>
    <g ref="chart">
      <g ref="areas"/>
      <g ref="paths"/>
    </g>
  </svg>
</template>

<script>
/**
 * IcaBody chart component
 * 1. Y axis upwards - Y values (screen) downwards
 * 2. properties: survey expected as array of 14 objects, upwards order:
 *    [
 *      { area: '14 Financial stability',
 *        received: 0,
 *        given: 0 },
 *      { area: '13 Family of origin',
 *        received: 0,
 *        given: 0 },
 *      ...
 *      { area: '1 Spiritual life',
 *        received: 0,
 *        given: 0 }
 *    ]
 * 
 * 3. properties:
 *    chartLayout = {
 *      size: 600, // squared area
 *      minifiedSize = 300, // "minified" view
 *      anchorLeft: 0, // chart anchor point
 *      anchorTop: 0 // chart anchor point
 *    },
 *    chartTitle = 'user name'
 *    bDebug = false // enables wireframe+intersections view
 *    bNumbers = true // enable chart numbers
 *    bAreaLabels = true // enable chart area labels
 *    bTitleLabel = true // enable bottom chart title label
 *    screenshotMode = false // set screenshot UI
 *  
 * 4. areas are built bottom up along given line then top down along received line
 */
import * as d3 from 'd3';

export default {
  name: 'SplinesChart',

  data() {
    return {
      debug: false,

      wholeArea: { // whole area including labels
        width: null,
        height: null
      },
      margins: {
        left: null
      },
      chartArea: {
        width: null,
        height: null,
        titleLabelArea: null,
        areaLabelsSize: null,
        areaLabelsScreenshotSize: null,
        areaLabelsYOffset: null,
        numberLabelsSize: null,
        numberLabelsScreenshotSize: null,
        numberLabelsYOffset: null,
        titleLabelSize: null,
        top: null,
      },
      xDomain: null,
      armOffset: 15, // domain-based offset - arm level
      baseOffset: 2.2, // domain-based offset - 0 value
      topMinOffset: -0.25, // domain-based offset - top 0 level
      topMaxOffset: 0.25, // domain-based offset - top 10 value
      scale: {
        x: null,
        y: null
      },
      deltaBezierMoltiplicator: 0.6,
      coordinates: [],

      initialized: false,
    };
  },

  // data passed to component
  props: {
    chartLayout: {
      type: Object,
      // Parenthesize the body of function to return an object literal expression:
      default: () => ({
        size: null, // squared area
        minifiedSize: null,
        anchorLeft: null, // anchor x
        anchorTop: null // anchor y
      })
    },

    /**
     * Provide a set of 14 area definitions
     * [{
     *   area: <string>,
     *   answers: <array> [
     *     received: <number>,
     *     given: <number>
     *   ]
     * }...]
     */
    survey: {
      type: Object
    },
    showDebug: {
      type: Boolean,
      default: false,
    },
    showNumbers: {
      type: Boolean,
      default: false,
    },
    showAreaLabels: {
      type: Boolean,
      default: false,
    },
    showTitleLabel: {
      type: Boolean,
      default: false,
    },
    screenshotMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    chartTitle() {
      let title = '';
      if (this.survey) {
        if (this.survey.nickname) {
          title += this.survey.nickname;
        }
        if (this.survey.nickname && this.survey.createDate) {
          title += ' - ';
        }
        if (this.survey.createDate) {
          title += this.$moment(this.survey.createDate).format('DD/MM/YYYY');
        }
      }
      return title;
    },

  },

  watch: {

    chartLayout: {
      handler(newData, oldData) {
        if (this.debug) {console.log( this.$options.name + ' watch chartLayout:', this.chartLayout, 'newData:', newData, 'oldData:', oldData);}
        this.initialized = false;
        if (!this.initialized) {
          this.removeAll();
          this.init();
        } else {
          this.removeAll();
          this.drawAll();
        }
      },
      deep: true
    },

    survey: {
      handler(newData, oldData) {
        if (this.debug) {console.log(this.$options.name + ' watch survey:', this.survey, 'newData:', newData, 'oldData:', oldData);}
        if (!this.initialized) {
          this.init();
        } else {
          this.removePaths();
          this.calculateCoordinates();
          this.drawPaths();
        }
      },
      deep: true
    },

    showDebug: function(value) {
      if (this.debug) {console.log(this.$options.name + ' watch showDebug:', this.showDebug, 'value:', value);}
      if (!this.initialized) {
        this.init();
      } else {
        if (!value) {
          this.removeAxes();
        } else {
          this.drawAxes();
        }
      }
    },

    showTitleLabel: function(value) {
      if (this.debug) {console.log(this.$options.name + ' watch showTitleLabel:', this.showTitleLabel, 'value:', value);}
      if (!this.initialized) {
        this.init();
      } else {
        if (!value) {
          this.removeTitle();
        } else {
          this.drawTitle();
        }
      }
    },

    showNumbers: function(value) {
      if (this.debug) {console.log(this.$options.name + ' watch showNumbers:', this.showNumbers, 'value:', value);}
      if (!this.initialized) {
        this.init();
      } else {
        if (!value) {
          this.removeNumberLabels();
        } else {
          this.drawNumberLabels();
        }
      }
    },

    showAreaLabels: function(value) {
      if (this.debug) {console.log(this.$options.name + ' watch showAreaLabels:', this.showAreaLabels, 'value:', value);}
      if (!this.initialized) {
        this.init();
      } else {
        if (!value) {
          this.removeAreaLabels();
        } else {
          this.drawAreaLabels();
        }
      }
    },

    screenshotMode: function(value) {
      if (this.debug) {console.log(this.$options.name + ' watch screenshotMode:', this.screenshotMode, 'value:', value);}
      if (!this.initialized) {
        this.init();
      } else {
        this.removeAll();
        this.drawAll();
      }
    },
  },

  mounted() {
    if (this.debug) console.log(this.$options.name + '.mounted()');
    this.addStyle();
    this.init();
  },

  methods: {
    init() {
      if (this.debug) { console.log(this.$options.name + '.init()'); }
      if (!this.initialized) {
        if (!this.checkSurveyValidity()) {
          this.initialized = false;
          return false;
        }
        // this.debug = true;
        this.xDomain = 10; // x axis domain hardcoded to 10
  
        this.wholeArea.width = this.chartLayout.size;
        this.wholeArea.height = this.chartLayout.size;
        this.chartArea.width = this.wholeArea.width * 0.75; // reserve area labels space
        this.chartArea.height = this.wholeArea.height * 0.85; // reserve title label space
        this.chartArea.titleLabelArea = (this.wholeArea.height - this.chartArea.height) * 0.7; // title label padding
  
        this.chartArea.areaLabelsSize = parseInt(this.chartArea.titleLabelArea * 0.3); // area label text size (px)
        this.chartArea.areaLabelsScreenshotSize = parseInt(this.chartArea.titleLabelArea * 0.25); // area label text size (px)
        this.chartArea.areaLabelsYOffset = this.chartArea.areaLabelsSize * 0.3; // area label text y offset
        this.chartArea.numberLabelsSize = parseInt(this.chartArea.titleLabelArea * 0.2); // area label text size (px)
        this.chartArea.numberLabelsScreenshotSize = parseInt(this.chartArea.titleLabelArea * 0.15); // area label text size (px)
        this.chartArea.numberLabelsYOffset = this.chartArea.numberLabelsSize * 0.3; // area label text y offset
        this.chartArea.titleLabelSize = parseInt(this.chartArea.titleLabelArea * 0.3); // title label text size (px)
  
        this.margins.left = this.chartLayout.anchorLeft + this.wholeArea.width * 0.03; // leftmost numbers padded anchor
        this.chartArea.top = this.chartLayout.anchorTop + this.wholeArea.height * 0.05; // top area padded anchor
  
        this.setScaleX();
        this.setScaleY();

        this.clipId = 'clip-' + this.survey.nickname.replaceAll(' ', '') + '-' + this.$moment(this.survey.createDate).format('YYYY-MM-DD-HH-mm-ss');
        this.$refs.clippingArea.id = this.clipId;

        this.initialized = true;

        this.drawAll();
      }
      return true;
    },

    /**
     * Return true if chard data is valid
     */
    checkSurveyValidity() {
      if (this.debug) { console.log(this.$options.name + '.checkSurveyValidity()'); }
      // if (this.debug) { console.log(this.$options.name + '.checkSurveyValidity() survey.completed:', this.survey.completed); }
      // if (this.debug) { console.log(this.$options.name + '.checkSurveyValidity() survey.answers:', this.survey.answers); }
      if (!this.chartLayout || !this.chartLayout.size) {
        return false;
      }
      if (
        this.survey &&
        this.survey.completed &&
        this.survey.answers &&
        this.survey.answers.length > 0
      ) {
        // check for valid values
        for (let i = 0; i < this.survey.answers.length; i++) {
          if (
            this.survey.answers[i].given < 0 ||
            this.survey.answers[i].given > 10 ||
            this.survey.answers[i].received < 0 ||
            this.survey.answers[i].given > 10
          ) {
            return false;
          }
        }
        if (this.debug) { console.log(this.$options.name + '.checkSurveyValidity() OK'); }
        return true;
      } else {
        return false;
      }
    },

    setScaleX: function() {
      if (this.debug) { console.log(this.$options.name + '.setScaleX()'); }
      if (this.xDomain != null && this.chartArea.width != null) {
        this.scale.x = d3
        .scaleLinear()
        .domain([this.xDomain * 2.5 * -1, this.xDomain * 2.5]) // remap domain < -10..10 > to < -25..25 >
        .range([this.margins.left, this.margins.left + this.chartArea.width]);
        this.isUpdateScale = false;
        this.isUpdateScale = false;
      }
    },
    setScaleY: function() {
      if (this.debug) { console.log(this.$options.name + '.setScaleY()'); }
      if (this.xDomain != null && this.chartArea.width != null) {
        this.scale.y = d3
        .scaleLinear()
        .domain([0, this.survey.answers.length + 2]) // add 1 'ankle' empty level + 1 '0' top level
        .range([
          this.chartArea.top + this.chartArea.height,
          this.chartArea.top
        ]);
        this.isUpdateScale = false;
      }
    },

    drawAll() {
      if (this.debug) { console.log(this.$options.name + '.drawAll()'); }
      this.calculateCoordinates();
      this.drawPaths();
      this.drawAreaLabels();
      this.drawNumberLabels();
      this.drawTitle();
      if (this.showDebug) {
        this.drawAxes();
      }
    },
    removeAll() {
      if (this.debug) { console.log(this.$options.name + '.removeAll()'); }
      this.removePaths();
      this.removeAreaLabels();
      this.removeNumberLabels();
      this.removeTitle();
      this.removeAxes();
    },

    calculateCoordinates() {
      if (this.debug) console.log(this.$options.name + '.calculateCoordinates()');
      let coordinates = []
      let coordinated, item, value, y, x, xNeg;
      for (let index = 0; index < this.survey.answers.length; index++) {
        item = this.survey.answers[index];
        // prepare object
        coordinated = {
          given: {},
          received: {},
          area: {},
          numbers: [],
        };

        // calculate standard y
        y = (index < 13 ? this.scale.y(14 - index) : this.scale.y(13 - index));

        // foreach given and received
        ['given', 'received'].forEach((field) => {
          value = item[field];
          if (index === 0) { // first vertical value
            x = xNeg = this.scale.x(0);
            const receivedMap = this.map_range(value, 0, this.xDomain, 0, 2);
            const receivedOffset = this.map_range(receivedMap, 0, 2, this.topMinOffset, this.topMaxOffset);
            y = this.scale.y(14 + receivedMap + receivedOffset);
          }
          else {
            x = (index === 4 ? value + this.armOffset : value + this.baseOffset);
            xNeg = this.scale.x(-1 * x);
            x = this.scale.x(x);
          }
          coordinated[field].y = y;
          coordinated[field].x = x;
          coordinated[field].xNeg = xNeg;
        });

        // calculate area's coordinates
        // if (this.showAreaLabels) {
          if (index === 0) {
            y = this.scale.y(15 - index);
          } else if (index === 13) {
            y = this.scale.y(13.2 - index);
          }
          coordinated.area.y = y;
          x = this.scale.x((index === 4 ? this.armOffset : this.baseOffset) + 15);
          coordinated.area.x = x;
          coordinated.area.text = item.area;
        // }

        // calculate numbers's coordinates
        // if (this.showNumbers) {
          [false, true].forEach((negative) => {
            [0, 5, 10].forEach((value) => {
              if (index === 0) { // first vertical value
                const receivedMap = this.map_range(value, 0, this.xDomain, 0, 2);
                const receivedOffset = this.map_range(receivedMap, 0, 2, this.topMinOffset, this.topMaxOffset);
                coordinated.numbers.push({
                  x: this.scale.x(0),
                  y: this.scale.y(14 + receivedMap + receivedOffset),
                  text: value,
                  rotate: (index === 0 ? true : false),
                });
              }
              else {
                coordinated.numbers.push({
                  x: this.scale.x((index === 4 ? value + this.armOffset : value + this.baseOffset) * (negative ? -1 : 1)),
                  y,
                  text: value,
                  rotate: (index === 0 ? true : false),
                });
              }
            });
          });
        // }
        coordinates.push(coordinated);
      }
      this.coordinates = coordinates;
    },

    /**
     * Draw path of field 'given' or 'received' in anticlockwise direction:
     * from bottom right, to top, to bottom left.
     * @param context must be `d3.path()`
     * @param field 'given' or 'received'
     * @param reverse draw in clockwise direction: from bottom left, to top, to bottom right.
     *                Used to move back in order to create the inner area.
     *                In reverse mode the first point is not a `moveTo` but a `lineTo`.
     * @param onlyEquals draw path only if values are equals (used to draw single lines when no areas are drawed)
     * @return context
     */
    drawPath(context, field, reverse = false, onlyEquals = false) {
      let index, x, y, equals, currX, currY, currEquals, deltaBezier;
      // first point bottom right (bottom left in reverse way)
      index = this.survey.answers.length - 1;
      x = reverse ? this.coordinates[index][field].xNeg : this.coordinates[index][field].x;
      y = this.coordinates[index][field].y;
      equals = this.survey.answers[index].given === this.survey.answers[index].received;
      // if (this.debug) console.log(this.$options.name + '.drawPath() index:', index, 'x:', x, 'y:', y);
      if (!reverse) {
        context.moveTo(x, y);
      } else {
        context.lineTo(x, y);
      }
      currX = x;
      currY = y;
      currEquals = equals;
      --index;
      // from first right point to second right point (from first left point to second left point in reverse way)
      x = reverse ? this.coordinates[index][field].xNeg : this.coordinates[index][field].x;
      y = this.coordinates[index][field].y;
      equals = this.survey.answers[index].given === this.survey.answers[index].received;
      // if (this.debug) console.log(this.$options.name + '.drawPath() index:', index, 'x:', x, 'y:', y);
      if (!onlyEquals || (equals && currEquals)) {
        deltaBezier = Math.abs((currY - y) * this.deltaBezierMoltiplicator);
        context.bezierCurveTo(currX, currY - deltaBezier, x, y + deltaBezier, x, y);
      } else {
        context.moveTo(x, y);
      }
      currX = x;
      currY = y;
      currEquals = equals;
      --index;
      // right points (left points in reverse way)
      while (index > 0) {
        x = reverse ? this.coordinates[index][field].xNeg : this.coordinates[index][field].x;
        y = this.coordinates[index][field].y;
        equals = this.survey.answers[index].given === this.survey.answers[index].received;
        // if (this.debug) console.log(this.$options.name + '.drawPath() index:', index, 'x:', x, 'y:', y);
        if (!onlyEquals || (equals && currEquals)) {
          deltaBezier = Math.abs((currY - y) * this.deltaBezierMoltiplicator);
          context.bezierCurveTo(currX, currY - deltaBezier, x, y + deltaBezier, x, y);
        } else {
          context.moveTo(x, y);
        }
        currX = x;
        currY = y;
        currEquals = equals;
        --index;
      }
      // from last right point to top point (from last left point to top point in reverse way)
      x = reverse ? this.coordinates[index][field].xNeg : this.coordinates[index][field].x;
      y = this.coordinates[index][field].y;
      equals = this.survey.answers[index].given === this.survey.answers[index].received;
      // if (this.debug) console.log(this.$options.name + '.drawPath() index:', index, 'x:', x, 'y:', y);
      if (!onlyEquals || (equals && currEquals)) {
        context.bezierCurveTo(currX, currY - Math.abs((currY - y) * this.deltaBezierMoltiplicator), x + Math.abs((currX - x) * this.deltaBezierMoltiplicator) * (reverse ? -1 : 1), y, x, y);
      } else {
        context.moveTo(x, y);
      }
      currX = x;
      currY = y;
      currEquals = equals;
      ++index;
      // from top point to first left point (from top point to first right point in reverse way)
      x = !reverse ? this.coordinates[index][field].xNeg : this.coordinates[index][field].x;
      y = this.coordinates[index][field].y;
      equals = this.survey.answers[index].given === this.survey.answers[index].received;
      // if (this.debug) console.log(this.$options.name + '.drawPath() index:', index, 'x:', x, 'y:', y);
      if (!onlyEquals || (equals && currEquals)) {
        context.bezierCurveTo(currX - Math.abs((currX - x) * this.deltaBezierMoltiplicator) * (reverse ? -1 : 1), currY, x, y - Math.abs((currY - y) * this.deltaBezierMoltiplicator), x, y);
      } else {
        context.moveTo(x, y);
      }
      currX = x;
      currY = y;
      currEquals = equals;
      ++index;
      // left points (right points in reverse way)
      while (index < 13) {
        x = !reverse ? this.coordinates[index][field].xNeg : this.coordinates[index][field].x;
        y = this.coordinates[index][field].y;
        equals = this.survey.answers[index].given === this.survey.answers[index].received;
        // if (this.debug) console.log(this.$options.name + '.drawPath() index:', index, 'x:', x, 'y:', y);
        if (!onlyEquals || (equals && currEquals)) {
          deltaBezier = Math.abs((currY - y) * this.deltaBezierMoltiplicator);
          context.bezierCurveTo(currX, currY + deltaBezier, x, y - deltaBezier, x, y);
        } else {
          context.moveTo(x, y);
        }
        currX = x;
        currY = y;
        currEquals = equals;
        ++index;
      }
      // from second last left point to last left point (from second last right point to last right point in reverse way)
      x = !reverse ? this.coordinates[index][field].xNeg : this.coordinates[index][field].x;
      y = this.coordinates[index][field].y;
      equals = this.survey.answers[index].given === this.survey.answers[index].received;
      // if (this.debug) console.log(this.$options.name + '.drawPath() index:', index, 'x:', x, 'y:', y);
      if (!onlyEquals || (equals && currEquals)) {
        deltaBezier = Math.abs((currY - y) * this.deltaBezierMoltiplicator);
        context.bezierCurveTo(currX, currY + deltaBezier, x, y - deltaBezier, x, y);
      } else {
        context.moveTo(x, y);
      }
      return context;
    },

    drawInternalArea(context) {
      // RECEIVED - move forward
      let field = 'received';
      this.drawPath(context, field);

      // GIVEN - move back
      field = 'given';
      this.drawPath(context, field, true);

      context.closePath()
      return context;
    },

    /**
     * Draw paths
     */
    drawPaths() {
      if (this.debug) console.log(this.$options.name + '.drawPaths()');

      d3.select(this.$refs.clippingArea)
      .append('path')
      .attr('d', this.drawInternalArea(d3.path()));
      // const internalArea = '' + this.drawInternalArea(d3.path());

      d3.select(this.$refs.areas)
      .append('path')
      .attr('class', 'givenArea')
      .attr('clip-path', 'url(#' + this.clipId + ')')
      .attr('d', this.drawPath(d3.path(), 'given'));

      d3.select(this.$refs.areas)
      .append('path')
      .attr('class', 'receivedArea')
      .attr('clip-path', 'url(#' + this.clipId + ')')
      .attr('d', this.drawPath(d3.path(), 'received'));

      d3.select(this.$refs.paths)
      .append('path')
      .attr('class', 'givenPath')
      .attr('d', this.drawPath(d3.path(), 'given', false, true));

      // d3.select(this.$refs.paths)
      // .append('path')
      // .attr('class', 'givenPath')
      // .attr('d', this.drawPath(d3.path(), 'given'));

      // d3.select(this.$refs.paths)
      // .append('path')
      // .attr('class', 'receivedPath')
      // .attr('d', this.drawPath(d3.path(), 'received'));
    },
    removePaths() {
      if (this.debug) console.log(this.$options.name + '.removePaths()');
      d3.select(this.$refs.clippingArea).selectAll('path').remove();
      d3.select(this.$refs.areas).selectAll('path').remove();
      d3.select(this.$refs.paths).selectAll('path').remove();
    },

    drawAreaLabels() {
      if (this.debug) console.log(this.$options.name + '.drawAreaLabels()');
      if (this.screenshotMode || (this.showAreaLabels && this.wholeArea.width > this.chartLayout.minifiedSize)) {
        for (let i = 0; i < this.coordinates.length; i++) {
          d3.select(this.$refs.newAreaLabels)
          .append('text')
          .attr('class', 'areaLabel')
          .style('font-size', (
              this.screenshotMode ?
              this.chartArea.areaLabelsScreenshotSize :
              this.chartArea.areaLabelsSize
            ) + 'px')
          .attr('x', this.coordinates[i].area.x)
          .attr('y', this.coordinates[i].area.y)
          .attr('transform', () => {
            return 'translate(0,' + this.chartArea.areaLabelsYOffset + ')'; // justify label to y tick
          })
          .text(this.coordinates[i].area.text);
        }
      }
    },
    removeAreaLabels() {
      if (this.debug) console.log(this.$options.name + '.removeAreaLabels()');
      d3.select(this.$refs.newAreaLabels).selectAll('text').remove();
    },

    drawNumberLabels() {
      if (this.debug) console.log(this.$options.name + '.drawNumberLabels()');
      if (this.screenshotMode || (this.showNumbers && this.wholeArea.width > this.chartLayout.minifiedSize)) {
        let numberObj, svgText;
        for (let i = 0; i < this.survey.answers.length; i++) {
          for (let j = 0; j < this.coordinates[i].numbers.length; j++) {
            numberObj = this.coordinates[i].numbers[j];
            svgText = d3.select(this.$refs.newNumberLabels)
            .append('text')
            .attr('class', 'numberLabel' + (this.screenshotMode ? ' screenshoot' : ''))
            .style('font-size', (
              this.screenshotMode ?
              this.chartArea.numberLabelsScreenshotSize :
              this.chartArea.numberLabelsSize
            ) + 'px')
            .attr('x', numberObj.x)
            .attr('y', numberObj.y)
            .attr('transform', () => {
              return 'translate(0,' + this.chartArea.numberLabelsYOffset + ')'; // justify label to y tick
            })
            .text(numberObj.text);
            if (numberObj.rotate) {
              svgText.style('writing-mode', 'vertical-rl');
            }
          }
        }
      }
    },
    removeNumberLabels() {
      if (this.debug) console.log(this.$options.name + '.removeNumberLabels()');
      d3.select(this.$refs.newNumberLabels).selectAll('text').remove();
    },

    /**
     * Title label
     */
    drawTitle() {
      if (this.debug) { console.log(this.$options.name + '.drawTitle()'); }
      if (this.screenshotMode || (this.showTitleLabel && this.wholeArea.width > this.chartLayout.minifiedSize)) {
        const titlePos = this.map_range(
          this.chartArea.titleLabelArea * 0.7,
          0, this.chartArea.top + this.chartArea.height,
          0, this.survey.answers.length
        );
        d3.select(this.$refs.newTitleLabel)
        .append('text')
        .attr('class', 'titleLabel' + (this.screenshotMode ? ' screenshoot' : ''))
        .style('font-size', this.chartArea.titleLabelSize + 'px')
        .attr('x', this.scale.x(0))
        .attr('y', this.scale.y(-titlePos)) // justify text below x axis
        .text(this.chartTitle); 
      }
    },
    removeTitle() {
      if (this.debug) console.log(this.$options.name + '.removeTitle()');
      d3.select(this.$refs.newTitleLabel).selectAll('text').remove();
    },

    /**
     * Debug axes
     */
    drawAxes() {
      if (this.debug) { console.log(this.$options.name + '.drawAxes()'); }
      if (this.scale.x != null && this.scale.y != null) {
        d3.select(this.$refs.axes)
        .append('g')
        .attr('class', 'axis')
        .attr('transform', () => {
          return 'translate(0,' + (this.chartArea.top + this.chartArea.height) +')';
        })
        .call(d3.axisTop(this.scale.x));

        d3.select(this.$refs.axes)
        .append('g')
        .attr('class', 'axis')
        .attr('transform', () => {
          return 'translate(' + (this.margins.left + this.chartArea.width * 0.5) + ',0)';
        })
        .call(d3.axisLeft(this.scale.y));
      }
    },
    removeAxes() {
      if (this.debug) console.log(this.$options.name + '.removeAxes()');
      d3.select(this.$refs.axes).selectAll('g').remove();
    },

    /**
     * Helper functions
     */
    map_range(value, low1, high1, low2, high2) {
      return low2 + ((high2 - low2) * (value - low1)) / (high1 - low1);
    },

    addStyle() {
      const css = `
      svg {
        font-family: 'Titillium Web', sans-serif;
      }
      .givenPath {
        stroke: #0b3b5e;
        stroke-width: 1;
        fill: none;
      }
      .receivedPath {
        stroke: #ff2a52;
        stroke-width: 1;
        fill: none;
      }
      .givenArea {
        stroke-width: 0;
        fill: #0b3b5e;
      }
      .receivedArea {
        stroke-width: 0;
        fill: #ff2a52;
      }
      .lineReceived {
        stroke: #ff2a52;
        stroke-width: 0px;
        fill: none;
      }
      .lineGiven {
        stroke: #0b3b5e;
        stroke-width: 0px;
        fill: none;
      }
      .area {
        fill-opacity: 1;
        stroke-width: 0px;
      }
      .numberLabel {
        font-weight: 300;
        fill: #666666;
        text-anchor: middle;
      }
      .areaLabel {
        font-weight: 300;
        fill: #666666;
      }
      .titleLabel {
        font-weight: 500;
        color: #0b3b5e;
        text-anchor: middle;
      }
      .titleLabel.screenshot {
        font-weight: 700;
      }
      .axis {
        fill-opacity: 1;
        stroke-width: 1px;
      }`;
      const svg = this.$refs.svgChart;
      const style = document.createElement('style');
      svg.appendChild(style);
      style.type = 'text/css';
      if (style.styleSheet){
        // This is required for IE8 and below.
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }
  }
};
</script>

<style>
</style>
